import React                from 'react';
import { useTranslation }   from 'react-i18next';
import PropTypes            from 'prop-types';
import Refresh              from '@material-ui/icons/Refresh';
import Input                from '@material-ui/core/Input';
import Paper                from '~/components/Paper';
import InputControl         from '~/components/Input/InputControl';
import InputSelect          from '~/components/Input/InputSelect';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import Form                 from '~/containers/Form';
import InputCheckBox        from '~/components/Input/InputCheckBox';
import SubscriptionRecord   from '~/records/SubscriptionRecord';
import langsEnum            from '~/enums/langsEnum';
import coinsEnum            from '~/enums/coinsEnum';

const attrName = (attr) => SubscriptionRecord.hummanAttributeName(attr);

function FormItem({record, handleChange, loading, onSubmit }) {
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  return (
    <Form onSubmit={onSubmit} isPersisted={isPersisted}>
      <Paper
        Icon={Refresh}
        iconColor={isPersisted ? 'purple' : 'blue'}
        title={t('subscription.defSingular')}
        loading={loading}
      >
        <GridContainer>
          <GridItem xs={12} md={8}>
            <InputControl
              name='name'
              value={record.get('name')}
              disabled={loading}
              required={true}
              label={attrName('name')}
              inputComponent={Input}
              onChange={handleChange}
            />
          </GridItem>
            <GridItem xs={8} sm={10} md={3}>
              <InputControl
                value={record.get('lang')}
                name="lang"
                disabled={loading}
                required={true}
                label={attrName('lang')}
                inputComponent={InputSelect}
                InputProps={{
                  options: langsEnum().array,
                  placeholder: t('subscription-language-placeholder'),
                  outValueType: 'string'
                }}
                onChange={handleChange}
              />
            </GridItem>
            <GridItem xs={4} sm={2} md={1}>
              <InputControl
                value={record.get('is_active')}
                name="is_active"
                disabled={loading}
                label={attrName('is_active')}
                inputComponent={InputCheckBox}
                onChange={handleChange}
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputControl
                value={record.get('coin')}
                name="coin"
                disabled={loading}
                required={true}
                label={attrName('coin')}
                inputComponent={InputSelect}
                InputProps={{
                  options: coinsEnum().array,
                  placeholder: t('subscription-currency-placeholder'),
                  outValueType: 'string'
                }}
                onChange={handleChange}
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputControl
                name='month_price'
                value={record.get('month_price')}
                disabled={loading}
                required={true}
                label={attrName('month_price')}
                inputComponent={Input}
                onChange={handleChange}
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputControl
                name='google_month_product_id'
                value={record.get('google_month_product_id')}
                disabled={loading}
                required={true}
                label={attrName('google_month_product_id')}
                inputComponent={Input}
                onChange={handleChange}
                />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputControl
                name='apple_month_product_id'
                value={record.get('apple_month_product_id')}
                disabled={loading}
                required={true}
                label={attrName('apple_month_product_id')}
                inputComponent={Input}
                onChange={handleChange}
              />
            </GridItem>
        </GridContainer>
      </Paper>
    </Form>
  );
}

FormItem.propTypes={
  loading:      PropTypes.bool,
  record:       PropTypes.instanceOf(SubscriptionRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit:     PropTypes.func.isRequired,
};

FormItem.defaultProps={
  loading: false,
};
export default FormItem;
